export default "__VITE_ASSET__H3$9$uOM__"